<c-card *transloco="let t">
  <c-card-body class="px-2">


          <c-row>
            <c-col md="6">
                <h1>{{ t('Lone Worker Shifts') }}</h1>
            </c-col>
            <c-col  md="6">

              <c-row class="justify-content-end">
                <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages>1">
                  <c-input-group  class="text-end">
                    <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
                    <select aria-label="Default select example" name="page" cSelect (change)="getShifts()"  [(ngModel)]="pagination.page">
                      <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
                    </select>
                  </c-input-group>
                </c-col>
                <c-col xs="auto" class="mb-2">
                  <c-input-group>
                    <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
                    <select aria-label="Default select example" (change)="getShifts()" name="sort" cSelect [(ngModel)]="sort">
                      <option value="newest">{{ t('Newest') }}</option>
                      <option value="oldest">{{ t('Oldest') }}</option>
                    </select>
                  </c-input-group>
                </c-col>
              </c-row>

            </c-col>
          </c-row>

      <div class="row mb-2">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="card mb-2">
            <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseFilter" aria-expanded="true" aria-controls="collapseFilter">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter & Export Shifts') }}
            </div>
            <div class="card-body collapse" id="collapseFilter">
              <form cForm class="align-items-center" (ngSubmit)="getShifts()">
                <div class="row mb-2">
                  <div class="col">
                    <div class="row mb-1">
                      <c-input-group>
                        <span cInputGroupText>
                          <svg cIcon class="me-2" name="cil-search"></svg>
                        </span>
                        <input cFormControl id="search" name="search" [(ngModel)]="search" placeholder="{{ t('Search') }}" />
                      </c-input-group>
                    </div>
                    <div class="row mb-1">
                      <div class="col">
                        <ng-select
                          [items]="okService.workers"
                          placeholder="{{ t('Worker') }}"
                          bindLabel="name"
                          bindValue="id"
                          name="worker_id"
                          [(ngModel)]="worker_id"
                        >
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row mb-1">
                      <c-input-group>
                        <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                        <input type="text" ngxDaterangepickerMd [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>
                      </c-input-group>
                    </div>
                    <div class="row mb-1" *ngIf="okService.groups">
                      <div class="col" *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                        <ng-select
                        [items]="okService.groups"
                        name="group"
                        placeholder="{{ t('Group') }}"
                        [(ngModel)]="group"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col align-items-center">
                    <button cButton class="btn btn-light" type="submit"><i class="fa-solid fa-magnifying-glass"></i> {{ t('Filter Shifts') }}</button>
                    &nbsp;
                    <button class="btn btn-info text-white" cButton (click)="exportShifts()">
                      <i class="fa-solid fa-file-excel"></i>
                      {{ t('Export Shifts') }}
                    </button>
                    &nbsp;
                    <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                      <i class="fa-solid fa-xmark"></i>
                    <span class="d-none d-lg-inline">
                       {{ t('Clear Filter') }}
                    </span>
                  </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>

          <c-row *ngIf="shifts">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col">{{ t('Timing') }}</th>
                    <th scope="col">{{ t('Status') }}</th>
                    <th scope="col">{{ t('Total Time') }}</th>
                    <th scope="col">{{ t('Locations') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let shift of shifts">
                      <td>
                        <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/shift/{{shift.id}}">
                          <i class="fa-solid fa-eye"></i> {{ t('View') }}
                        </button>
                      </td>
                      <th scope="row">
                        <div>
                          <span class="fs-5">{{shift.name}}</span>
                        </div>
                      </th>
                      <td>
                        <div class="small text-medium-emphasis">
                          <span>{{ t('Start') }}: {{shift.start}}</span><br/>
                          <span *ngIf="shift.end">{{ t('End') }}: {{shift.end}}</span>
                        </div>
                      </td>
                      <th>
                          <i class="fa-solid fa-clock text-warning" *ngIf="!shift.completed"></i>
                          <i class="fa-solid fa-circle-check text-success" *ngIf="shift.completed"></i>
                          {{shift.status}}
                      </th>
                      <td>
                        <span>{{shift.total_time}}</span>
                      </td>
                      <td>
                        <span class="badge bg-success" *ngIf="shift.location_count > 0">{{ t('Yes') }}</span>
                        <span class="badge bg-secondary" *ngIf="shift.location_count == 0">{{ t('No') }}</span>
                      </td>


                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

  </c-card-body>
</c-card>
